import { IReview } from '@trwl/views/main/components/ReviewBlock';

export const reviews: IReview[] = [
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2024-11-26_21-13-31.webp',
    text: (
      <>
        Приехали родненькие. 24 дня. <br />
        Очень удобно было заказать и отслеживать через сайт
      </>
    ),
  },
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2024-05-07_15-54-03.jpg',
    text: (
      <>
        Заказываю не первый раз, всегда все на высшем уровне! Очень крутые
        кроссовки! Спасибо
      </>
    ),
  },
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2024-04-13_05-37-41.jpg',
    text: <>Пришли ровно за 2 недели! Спасибо!!!</>,
  },
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2024-02-04_18-00-49.jpg',
    text: <>Превосходно! Спасибо, TRWL!</>,
  },
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2023-12-27_09-15-30.jpg',
    text: <>Все приехало в лучшем виде и в срок. Спасибо TRWL</>,
  },
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2023-12-24_22-12-50.jpg',
    text: (
      <>От души TRWL , как и говорил ранее работаем дальше! Ещё раз спасибо)</>
    ),
  },
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2023-10-17_21-57-12.jpg',
    text: (
      <>
        Мои новые красавцы приехали <br />
        Уже выбираю, что заказать следующее <br />
        Сомнений нет, что только через TRWL
      </>
    ),
  },
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2023-09-01_17-05-14.jpg',
    text: (
      <>
        Как всегда, всё чётко и быстро!) <br />
        Помогли с размером и с выбором модели. <br />
        Спасибо за стильный аутфит
      </>
    ),
  },
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2023-07-17_21-58-05.jpg',
    text: (
      <>
        Пришли мои кроссовки <br />
        Спасибо большое, буду советовать Вас смело друзьям и сам заказывать еще)
        Цена супер, качество, сроки
      </>
    ),
  },
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2023-05-18_21-20-42.jpg',
    text: (
      <>
        Спасибо большое за проделанную работу. <br />
        Кроссы огонь, сроки вообще порадовали! Скоро буду изики брать)
      </>
    ),
  },
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2023-05-13_14-58-39.jpg',
    text: <>Спасибо вам большущее за кроссы, сестра моя в восторге</>,
  },
  {
    imageURL:
      'https://storage.yandexcloud.net/trwl-static/site/review/photo_2023-03-21_22-20-33.jpg',
    text: (
      <>
        Купил кроссовки через TRWL, всё прошло очень хорошо: всё в сроки,
        отличная цена, отличный сервис. Рекомендую к работе!
      </>
    ),
  },
];
